import { forwardRef } from "react";
import { NavLink as RouterNavLink, NavLinkProps as RouterNavLinkProps } from "react-router-dom";

import { PrefetchConfig, PrefetchHandler } from "@/domain/_shared/preloader/components/prefetch-handler";
import { cn } from "@/lib/cn";

interface NavLinkProps extends RouterNavLinkProps {
  prefetchConfig?: Omit<PrefetchConfig, "to">;
  replace?: boolean;
}

export const NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ prefetchConfig, replace = false, onClick, ...props }, ref) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.currentTarget.click();
      }
    };

    return (
      <PrefetchHandler
        prefetchConfig={{ onMouseEnter: props.onMouseEnter, ...prefetchConfig, to: props.to.toString() }}
      >
        <RouterNavLink
          ref={ref}
          {...props}
          replace={replace}
          onClick={onClick}
          onKeyDown={handleKeyDown}
          role="link"
          tabIndex={0}
          className={cn(
            props.className,
            // Inset so the ring survives overflow-clipping ancestors (tab strips, sidebars)
            "focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus",
          )}
        />
      </PrefetchHandler>
    );
  },
);

NavLink.displayName = "NavLink";
